var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-conts-wrap"},_vm._l((_vm.contentList),function(item,index){return _c(_vm.doComponent(item),{key:index,tag:"component",attrs:{"contentNo":_vm.contentList[index].contentNo,"grpList":_vm.grpList,"depth":_vm.depth}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }